export default __webpack_public_path__ + "static/images-desktop-ef1fae22beffde66aa386d605c59b873.png";